import { Button, Modal } from '@roo/roo';
import * as React from 'react';
import './index.scss';

interface IProps {
    modalVisible: boolean;
    closeModal: () => void;
}
function InvoicingModal(props: IProps) {
    const { modalVisible } = props;

    function handleCloseModal() {
        props.closeModal();
    }

    return (
        <Modal
            visible={modalVisible}
            className="invoicingModal"
            onCancel={handleCloseModal}
            showConfirmButton={false}
            cancelText="我知道了"
            closeButtonProps={{ type: 'brand' }}
            size="lg"
        >
            <div>
                <h3>纸质发票：快递（不支持到付）</h3>
                <p>收件人：财务共享中心/对公支付</p>
                <p>电话：010-57376600-6491</p>
                <p>地址：北京市朝阳区望京东路4号院恒电大厦BC座美团总部</p>
                <p>资料：1. 发票</p>
                <p style={{ marginLeft: '42px' }}>2. 发票交接单</p>
                <h3>电子发票：电子邮件</h3>
                <p>邮箱：fpf.fsscpayable@meituan.com</p>
                <p>标题：电子发票-服务商名称（即XX公司）</p>
                <p>正文：1. 服务商名称（即XX公司）</p>
                <p style={{ marginLeft: '42px' }}>2. 您的联系人姓名与电话</p>
                <p>附件：1. 电子发票（PDF、OFD格式）</p>
            </div>
            <div className="template-download">
                <span>发票交接单模板</span>
                <a href="https://s3plus.meituan.net/v1/mss_0e4451a82e1d428f9fc3b99c0b3ebf15/cdn/doc/fapiaojiaojiedan.docx">
                    <Button type="brand-text">点击下载</Button>
                </a>
            </div>
        </Modal>
    );
}

export default InvoicingModal;
